import { ModalButton } from "./ModalButton";
import { MailchimpNewsletterForm } from "./MailchimpNewsletterForm";
import { useTranslation } from "react-i18next";

export function NewsletterModalButton(props) {
    const { t } = useTranslation();

    return (
        <ModalButton
            label={t("cta-newsletter-button-label")}
            contentLabel={t("newsletter-section-title")}
            wrapperClassName="flex flex-col items-center justify-center w-full min-w-xs"
            className={`!text-base w-auto max-w-lg ${
                props.className ? props.className : ""
            }`}
        >
            <MailchimpNewsletterForm className="styled-markdown text-black flex flex-col mx-10 mt-2 mb-10 md:mx-16" />
        </ModalButton>
    );
}
